(()=>{
if(window.nlStockRulesReady)return;window.nlStockRulesReady=true;
const init=main=>{
 if(main.dataset.nlStockReady)return;
 const config=main.querySelector('[data-nl-stock-variants]');if(!config)return;
 main.dataset.nlStockReady='true';
 const variants=JSON.parse(config.textContent);
 const update=()=>{
  const selection=main.querySelector('variant-selection');
  const id=selection?.getAttribute('variant')||main.querySelector('form[action*="/cart/add"] [name="id"]')?.value||main.dataset.nlInitialVariant;
  const v=variants[id],out=!!v?.tracked&&v.quantity<=0;
  main.dataset.nlInStock=String(!!v?.available&&!out);
  const notify=main.querySelector('[data-nl-notify]');if(notify)notify.hidden=!(out&&!v?.available);
  const preorder=main.querySelector("[data-nl-quick-preorder]");if(preorder)preorder.hidden=!(out&&v?.available);
 };
 main.addEventListener('change',()=>setTimeout(update,0));
 const selection=main.querySelector('variant-selection');
 if(selection)new MutationObserver(update).observe(selection,{attributes:true,attributeFilter:['variant']});
 update();
};
const start=()=>document.querySelectorAll('.product-main').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
document.addEventListener('shopify:section:load',start);
new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches?.('.product-main')||node.querySelector?.('.product-main')))))start();}).observe(document.documentElement,{childList:true,subtree:true});
})();